import React, {useRef, useEffect, useContext} from "react";
import MoveHandle from "../../assets/images/move-handle.svg";
import $ from 'jquery';
import FloContext from "../contexts/floContext";
import FileOptions from "../options/fileOptions";

export default function Files(props: any) {
   const {folder, file, index} = props;
   const draggableFile = useRef(null);

   const {
      filesAndFolders,
      draggedFolder,
      droppedFolder,
      onDragging,
      onDropped,
      selectedFile,
      selectedToEditFile,
      onFileSelect,
      onFileRename
   }: any = useContext(FloContext)

   const enableFileDrag = () => {
      $((draggableFile.current) as any).draggable({
         axis: 'y',
         revert: (val: any) => {
            const {_id: draggedFolderId} = draggedFolder.current;
            const {_id: droppedFolderId} = droppedFolder.current;
            return draggedFolderId === droppedFolderId;
         },
         start: event => {
            onDragging(folder, file);
         },
         stop: event => {
            onDropped();
         }
      })
   }

   const saveFileName = (e: any) => {
      if (e._reactName === 'onKeyPress' && e.key === "Enter") {
         onFileRename(folder, file, e.currentTarget.value)
      } else if (e._reactName === 'onBlur') {
         onFileRename(folder, file, e.currentTarget.value)
      }
   }

   useEffect(() => {
      enableFileDrag();
   }, [filesAndFolders])



   return(
       <li ref={draggableFile}
           className={'file flex options-box '
               + (selectedToEditFile._id === file._id ? 'edit-mode ' : '')
               + (selectedFile._id === file._id ? 'selected ' : '')}
           key={index} onClick={() => onFileSelect(folder, file)}>
          <div className="file-content flex">
             <div className="icon file-icon">
                <img src={require('../../assets/images/file.png')} alt=""/>
             </div>
             <div className="file-name">
                { (selectedToEditFile._id === file._id) &&
                    <input defaultValue={file.name}
                           autoFocus={true}
                           onBlur={saveFileName}
                           onKeyPress={saveFileName}
                           name="file"
                           className="file-name-edit" type="text"/>
                }
                { (selectedToEditFile._id !== file._id) &&
                    <div className="text-ellipsis">{file.name}</div>
                }
             </div>
             <FileOptions folder={folder} file={file} />
          </div>
          <div className="icon width-16 padding-l-5 move-handle">
             <img src={MoveHandle} alt=""/>
          </div>
       </li>
   )
}
